module.exports = __webpack_public_path__ + "img/img1.f4171472.jpg";